<template>
	<component
		v-if="visible"
		:is="componentOfPart(selectedPart)"
		:part="partRef(selectedPart)"
		:data="localData"
		:readonly="ro"
		:viewmode="vm"></component>
</template>

<script setup lang="ts">
import useContainer, { type ContainerProps, containerProps } from "./Container";
import {ref, defineProps, onMounted, onUnmounted, computed} from "vue";
import type {Responsive} from "@t/fd/layout/Responsive";

const props = defineProps({
	...containerProps,
}) as ContainerProps;

const part = computed<Responsive>(() => props.part as Responsive);

const { componentOfPart, partRef, localData, ro, vm, visible } = useContainer(props);
const windowWidth = ref(document.documentElement.clientWidth);

function updateWindowWidth() {
	windowWidth.value = document.documentElement.clientWidth;
}

const selectedPart = computed(() => {
	for (let item of part.value.items) {
		const min = item.minWidth;
		if (typeof min !== "number" || windowWidth.value >= min) return item;
	}
	// return the last item if there is no match
	return part.value.items[part.value.items.length - 1];
});

onMounted(() => {
	window.addEventListener("resize", updateWindowWidth);
});
onUnmounted(() => {
	window.removeEventListener("resize", updateWindowWidth);
});
</script>
